// `extension-alert-candidates.tpl.html:1` — the candidate list component's own three wrappers,
// plus the element they hang off.
//
// ⚠️ THEY LOOK LIKE PURE NESTING AND THEY ARE NOT. `.extension-candidate-alert-list` is where
// `_extension-alert-candidates.scss:139` puts the ROW'S COLOUR:
//
//     .extension-candidate-alert-list {
//       .shortlist-candidate, .shortlist-candidate-slim { color: #003459; … }
//     }
//
// so without this div every candidate name inherits the body's grey. That failure has no
// layout symptom at all — the geometry stays pixel-exact — and bold grey text where bold navy
// belongs reads as a font that did not load, which is a long way from the actual cause.
//
// It also carries `border-top: 1px solid` (removed again in slim mode by
// `.shortlist-content-container-slim .extension-candidate-alert-list`), so the two classes have
// to travel together: keeping the wrapper and dropping the slim modifier draws a line
// production does not have.
import { createElement, type ReactElement, type ReactNode } from 'react'

export interface CandidateListHostProps {
  /** `<extension-alert-candidates>` / `<extension-alert-client-contacts>`, styled as a pair. */
  entity?: 'candidates' | 'clientContacts'
  /** `ng-class="{'in-loading': ctrl.loading}"` — suppresses the row transitions mid-fetch. */
  loading?: boolean
  children?: ReactNode
}

export function CandidateListHost({
  entity = 'candidates',
  loading = false,
  children,
}: CandidateListHostProps): ReactElement {
  return createElement(
    entity === 'candidates' ? 'extension-alert-candidates' : 'extension-alert-client-contacts',
    null,
    <div className={`extension-candidate-alert-list${loading ? ' in-loading' : ''}`}>
      <div className="extension-candidate-alert-list-view-wrap">
        {/* `ng-if="currentViewMode !== FullMode"` — the frame is always slim here. */}
        <div className="extension-candidate-alert-list-non-full-view">{children}</div>
      </div>
    </div>,
  )
}
